/* Kallov counters. Loaded on every page from snippets/kallov-motion.liquid, before kallov-house.js.

   One small function, window.KallovCount(name, detail, once), counts the moments that matter on the site:
   The Mirror opened, a map saved, Find Your Girlie started and finished, the size card and the Mirror card
   shown, the medical questions ticked, a preorder, The Refresh booked, the tracker opened, the first-look
   list joined, the stylist locator used.

   Where the counts go:
   1. Google Analytics, when a measurement ID is set on the shop (metafield kallov.ga4_id). Every count is a
      GA4 event with the same name, and every page view comes for free.
   2. Shopify's customer events (Shopify.analytics.publish), so any pixel added later hears the same events.
   3. A tally on this phone, which rides on her order as a cart attribute, so every order says whether she
      looked in The Mirror or took the quiz before she bought.

   Nothing here identifies anyone. No picture, no map, no name. Just that a thing happened. */
(function () {
  'use strict';
  var CFG = window.KallovHouse || {};
  var GA = CFG.ga4 || '';
  var KEY = 'kallovCounts';
  function tally() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(t) { try { localStorage.setItem(KEY, JSON.stringify(t)); } catch (e) {} }
  function onceKey(name) { return 'kc_' + name; }

  function count(name, detail, once) {
    detail = detail || {};
    if (once) { try { if (sessionStorage.getItem(onceKey(name))) return; sessionStorage.setItem(onceKey(name), '1'); } catch (e) {} }
    var t = tally(); t[name] = (t[name] || 0) + 1; save(t);
    try { if (window.gtag) window.gtag('event', name, Object.assign({ event_category: 'kallov', page_path: location.pathname }, detail)); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; if (!window.gtag) window.dataLayer.push(Object.assign({ event: 'kallov_' + name }, detail)); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('kallov_' + name, detail); } catch (e) {}
  }
  window.KallovCount = count;
  window.KallovCount.tally = tally;
  window.KallovCount.summary = function () {
    var t = tally(), parts = [];
    Object.keys(t).sort().forEach(function (k) { parts.push(k + ' ' + t[k]); });
    return parts.join(', ');
  };

  /* ---------- Google Analytics, only when an ID is set and analytics is allowed ---------- */
  function loadGA() {
    if (!GA || window.gtag) return;
    var s = document.createElement('script'); s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA, { anonymize_ip: true });
  }
  if (GA) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
      if (cp.analyticsProcessingAllowed()) loadGA();
      else document.addEventListener('visitorConsentCollected', function (e) { try { if (e.detail && e.detail.analyticsAllowed) loadGA(); } catch (x) {} });
    } else loadGA();
  }

  /* ---------- The Mirror: opened, and a map saved ---------- */
  var setItem = Storage.prototype.setItem;
  Storage.prototype.setItem = function (k, v) {
    var had = false;
    if (k === 'kallovHairline') { try { var old = JSON.parse(localStorage.getItem(k) || 'null'); had = !!(old && old.map); } catch (e) {} }
    var r = setItem.apply(this, arguments);
    if (k === 'kallovHairline') {
      try { var m = JSON.parse(v); if (m && m.map) count(had ? 'mirror_updated' : 'mirror_saved', { shade: m.map.lace && m.map.lace.name || '', chosen_by: m.map.lace && m.map.lace.chosenBy || 'camera', page_path: location.pathname }); } catch (e) {}
    }
    return r;
  };

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    // The Mirror counts as opened when she opens the camera, not when a page happens to hold it

    /* Find Your Girlie: started, finished */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && t.closest('[data-kq-begin]')) count('quiz_started', {}, true);
      if (t.closest && t.closest('[data-km-open]')) count('mirror_opened', { page_path: location.pathname }, true);
      if (t.closest && t.closest('[data-km-skip]')) count('mirror_skipped', {}, true);
      if (t.closest && t.closest('[data-ks-near]')) count('stylists_near_me', {});
      if (t.closest && t.closest('.kt-stop')) count('tracker_stop_tapped', {});
    }, true);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('kallov-match-quiz').then(function () {
        var q = document.querySelector('kallov-match-quiz'); if (!q) return;
        var proto = Object.getPrototypeOf(q), orig = proto.renderResult;
        if (!orig || orig.__kc) return;
        proto.renderResult = function (result) {
          try { var p = result && result.primary && result.primary.product; count('quiz_finished', { girlie: p && p.title || '', closest: !!(result && result.relaxedLabel) }); } catch (e) {}
          return orig.apply(this, arguments);
        };
        proto.renderResult.__kc = true;
      });
    }

    /* The First Look: joined */
    var fl = document.querySelector('input[name="contact[tags]"][value="first-look"]');
    if (fl && fl.form) fl.form.addEventListener('submit', function () { count('first_look_joined', {}); });

    /* The tracker: opened with a real order */
    var kt = document.querySelector('[data-kt]');
    if (kt && !kt.hidden) count('tracker_opened', {}, true);

    /* The stylist locator: searched */
    var ks = document.querySelector('[data-ks-q]');
    if (ks) ks.addEventListener('input', function () { if (ks.value.length >= 3) count('stylists_searched', {}, true); });

    /* The Refresh: booked */
    var refresh = document.querySelector('.kallov-refresh-fields');
    if (refresh) document.addEventListener('submit', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('.kallov-refresh-fields')) count('refresh_booked', {}); }, true);
  });

  /* ---------- The tally rides on her order ---------- */
  window.KallovCount.attach = function () {
    var s = window.KallovCount.summary(); if (!s) return;
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { 'Kallov counts': s } }), keepalive: true });
    } catch (e) {}
  };
})();
